import medicalSolutionsImg from "./img/healthcare-image.png"
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { isMARINE } from 'services/instances';
import { MEDICAL_SOLUTIONS_URL } from 'components/Header/components/HeaderMainMenu/components/HeaderProductsDropdown/components/HeaderFilmSolutionsLink/constants';

const HealthcareSolutionsItem = () => {

  return (
    <div className="col-12 col-md-6 col-lg-4 mb-4">
      <div className="product-line">
        <div className="product-line__photo mb-4">
          <img
            src={medicalSolutionsImg}
            alt="medical-solutions-img"
            title="medical-solutions"
            className="img-fluid"
          />
        </div>
        <h3 className="product-line__title text-weight-bold text-size-h4">
          <a href={MEDICAL_SOLUTIONS_URL}>
            <FormattedMessage
              id="HeaderProductsDropdown.healthcareSolutions"
              defaultMessage="Healthcare solutions"
              values={{
                br: <br />
              }}
            />
          </a>
        </h3>
        <p className="product-line__description text-left text-size-small gray-light pl-4 pr-4">
          <FormattedMessage 
            id="ProductLine.healthcareSolutionsDescription" 
            defaultMessage="Our films are designed to meet the strict functional, 
            regulatory, and hygiene standards of the medical industry. 
            From enteral feeding and drainage systems to compression therapy, our materials deliver performance, safety, and consistency." />
        </p>
        <div className="product-line__button-container text-center">
          <a
            href={MEDICAL_SOLUTIONS_URL}
            className={classNames({
              "btn btn-outline-dark": true,
              "btn-outline-prussian-blue": isMARINE(),
            })}
          >
            <FormattedMessage
              id="ProductLine.seeMoreButton"
              description="See more button label at product line component"
              defaultMessage="Quiero saber más"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default HealthcareSolutionsItem